<template>
  <VanPopup
    v-model:show="mateStore.showDriftCategoryModal"
    position="bottom"
    class="drift-capsule-modal"
  >
    <div
      class="celestial-background overflow-auto min-h-screen w-full flex flex-col justify-center items-center p-4 relative"
    >
      <!-- <div
        ref="starrySkyContainer"
        class="fixed top-0 left-0 w-full h-full pointer-events-none overflow-hidden z-0"
      ></div> -->
      <DriftCapsuleDot class="fixed" />

      <div class="absolute top-0 left-2 right-2 flex justify-between mt-3">
        <div
          class="bg-black/30 backdrop-blur-sm rounded-full flex items-center"
        >
          <CrystalPowerCount class="text-white" />
        </div>
        <div class="flex items-center gap-2">
          <div
            class="bg-black/30 backdrop-blur-sm rounded-full w-8 h-8 flex items-center justify-center"
            @click="showDescriptionModal = true"
          >
            <i
              class="mingcute--question-line iconify text-white cursor-pointer text-base"
            />
          </div>
          <div
            class="bg-black/30 backdrop-blur-sm rounded-full w-8 h-8 flex items-center justify-center"
            @click="clickClose"
          >
            <i
              class="iconify mingcute--close-line text-white text-xs cursor-pointer"
            />
          </div>
        </div>
      </div>

      <div class="text-center mb-8 mt-16 z-10 relative">
        <h1
          class="text-4xl text-white font-bold"
          style="text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3)"
        >
          次元漂流仓
        </h1>
        <p
          class="text-lg text-white mt-2"
          style="text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2)"
        >
          打捞休眠仓，唤醒沉睡的伙伴
        </p>
      </div>

      <div class="relative z-10 text-center">
        <div class="card-pack-glow"></div>
        <img
          src="/img/drift-capsule-main.gif"
          alt="休眠仓"
          :class="[
            'card-pack w-40 rounded-2xl',
            { disabled: currentCategory?.availableCapsuleCount! <= 0 },
            { shake: isShaking },
          ]"
          @click="handleCardPackClick"
        />
        <p
          class="text-white text-lg mt-2 font-bold flex items-center gap-1"
          style="text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5)"
        >
          打捞一次: 消耗 <CrystalIcon class="w-[29px] h-6" /> {{ DRAW_COST }}
        </p>
      </div>

      <p
        :class="[
          'text-white text-lg mt-8 h-8 transition-opacity duration-500 text-center z-10 relative',
          { 'opacity-0': !showDrawMessage },
        ]"
      >
        {{ drawMessage }}
      </p>

      <div class="flex gap-2 mt-4 flex-col">
        <div class="text-lg font-bold rarity-3">稀有角色：</div>

        <div class="flex gap-2">
          <div
            v-for="(item, index) in list"
            :key="item"
            @click="modalStore.openMediaPreviewModal(list, index)"
          >
            <img
              :src="item"
              alt=""
              class="w-[50px] rounded"
              crossorigin="anonymous"
            />
          </div>
        </div>
      </div>

      <!-- <button
        class="btn btn-ghost text-white"
        @click="showDescriptionModal = true"
      >
        打捞说明
      </button> -->

      <!-- 能量块显示和补充 -->
      <!-- <div
        class="fixed bottom-5 left-1/2 -translate-x-1/2 z-20 flex items-center gap-4 bg-black/30 backdrop-blur-sm p-3 rounded-full"
      >
        <PowerIcon class="ml-2" />
        <span class="text-white text-xl font-bold">{{ currentEnergy }}</span>
      </div> -->

      <!-- 结果弹窗 -->
      <div
        :class="[
          'modal-overlay fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50 p-4',
          { 'opacity-0 pointer-events-none': !showModal },
        ]"
        @click="handleModalClick"
      >
        <div class="relative card-reveal flex flex-col items-center">
          <UserAvatar
            :mate="selectedCard?.prizeMate"
            :class="['max-w-[80%] max-h-[70vh]', cardGlowClass]"
          />
          <div class="text-center mt-4">
            <p
              class="text-white text-2xl font-bold"
              style="text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.7)"
            >
              {{ selectedCard?.prizeMate?.name }}
            </p>
            <p
              :class="[
                'text-xl font-bold mt-1 ',
                rarityTextClass,
                `rarity-${selectedCard?.rarity}`,
              ]"
              style="text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.7)"
            >
              {{ $t(`mission.equipment.rarity.${selectedCard?.rarity}`) }}
            </p>
          </div>
        </div>
        <button
          @click="closeModal"
          class="absolute top-4 right-4 h-12 w-12 rounded-full bg-black/30 flex items-center justify-center text-white focus:outline-none focus:ring-2 focus:ring-white/50"
        >
          <svg
            class="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
      </div>

      <VanPopup
        v-model:show="showDescriptionModal"
        closeable
        class="pt-8 max-h-[80%] bg-black/30 backdrop-blur-sm"
      >
        <div
          class="text-white whitespace-pre-wrap p-4"
          style="text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2)"
        >
          {{ currentCategory?.description }}
        </div>
      </VanPopup>
    </div>
  </VanPopup>
</template>

<script setup lang="ts">
import { DriftCapsuleRarity } from "@/enums/mateEnums";
import { DriftCapsule, DriftCategory } from "@/types/mate";
import { ref, computed } from "vue";
import { useMate } from "@/stores/mate";
import { useGlobalModal } from "@/stores/globalModal";
import { useGlobalUser } from "@/stores/globalUser";
import { useRoute } from "vue-router";
import { routerBack } from "@/use/go";
import DriftCapsuleDot from "./DriftCapsuleDot.vue";

const mateStore = useMate();
const emit = defineEmits<{
  (e: "reload"): void;
}>();
const props = defineProps<{
  category: DriftCategory;
}>();

// 数据类型定义

// 响应式数据

const isDrawing = ref(false);
const showModal = ref(false);
const showDrawMessage = ref(false);
const drawMessage = ref("");
const selectedCard = ref<DriftCapsule | null>(null);
const isShaking = ref(false);
const userStore = useGlobalUser();
const showDescriptionModal = ref(false);

const list = [
  "https://bingciyuan-api.oss-cn-beijing.aliyuncs.com/mate/202507/11/e4KJuOhMHCoesLrhTgY0T0AqlDXitzvGygg79lZb.gif",
  "https://bingciyuan-api.oss-cn-beijing.aliyuncs.com/mate/202507/11/HFeLA9tug4BCJsfaGKmDtR6G1g3oWB1kgyyO9MJe.gif",
  "https://bingciyuan-api.oss-cn-beijing.aliyuncs.com/mate/202507/11/h9qKWP0wWHO0NcLuBnDHV3wKJE1UbDFj9u8OxQe9.gif",
  "https://bingciyuan-api.oss-cn-beijing.aliyuncs.com/mate/202507/11/8kbJK3858NfE4S1IkLRV1JpW4nugUK8Egak2JYet.gif",
  "https://bingciyuan-api.oss-cn-beijing.aliyuncs.com/mate/202507/11/YKLAVMmWJE1fYmWAjSaNDtAjoo1cCFn40FlSy5DM.gif",
];

const currentCategory = computed(() => {
  return mateStore.driftCategoryList.find(
    (item) => item.id === props.category.id
  );
});

// 常量配置
const DRAW_COST = 4.9;
const modalStore = useGlobalModal();

// 计算属性
const cardGlowClass = computed(() => {
  if (!selectedCard.value) return "normal-glow";

  switch (selectedCard.value.rarity) {
    case DriftCapsuleRarity.Rare:
      return "rare-glow";
    case DriftCapsuleRarity.Epic:
      return "uncommon-glow";
    default:
      return "normal-glow";
  }
});

const rarityTextClass = computed(() => {
  if (!selectedCard.value) return "text-white";

  switch (selectedCard.value.rarity) {
    case DriftCapsuleRarity.Rare:
      return "text-blue-400";
    case DriftCapsuleRarity.Epic:
      return "text-green-400";
    default:
      return "text-white";
  }
});

const showMessage = (message: string, duration = 2000) => {
  drawMessage.value = message;
  showDrawMessage.value = true;
  setTimeout(() => {
    showDrawMessage.value = false;
  }, duration);
};

const handleCardPackClick = async () => {
  if (isDrawing.value) return;

  if (modalStore.shouldOpenCrystalNotEnoughModal(4.9)) {
    return;
  }

  isDrawing.value = true;
  isShaking.value = true;

  showMessage("正在打捞次元漂流物...", 1000);

  if (currentCategory.value?.availableCapsuleCount === 0) {
    showMessage("该领域已无休眠仓可打捞");
    setTimeout(() => {
      isDrawing.value = false;
      isShaking.value = false;
    }, 1000);
    return;
  }

  try {
    const res = await mateStore.postSalvageDriftCapsule(props.category.id);
    await userStore.refresh();
    await mateStore.fetchMateListSimple();

    emit("reload");

    selectedCard.value = res;

    showModal.value = true;
    isShaking.value = false;
    showDrawMessage.value = false;
  } catch {
    showMessage("打捞失败，请稍后重试");
  }
};

const closeModal = () => {
  showModal.value = false;
  isDrawing.value = false;
};

const handleModalClick = (e: Event) => {
  if (e.target === e.currentTarget) {
    closeModal();
  }

  if (!currentCategory.value) {
    mateStore.showDriftCategoryModal = false;
  }
};

const route = useRoute();
const clickClose = () => {
  if (route.query.categoryId) {
    routerBack();
  } else {
    mateStore.showDriftCategoryModal = false;
  }
};
</script>
